export const API_BASE = process.env.REACT_APP_API_BASE || '/api';
const TOKEN_KEY = 'mailo.session';
// Discard legacy non-expiring credentials from the former application.
localStorage.removeItem('token');
export function getToken() { return sessionStorage.getItem(TOKEN_KEY); }
export function setToken(token) { sessionStorage.setItem(TOKEN_KEY, token); }
export function clearToken() { sessionStorage.removeItem(TOKEN_KEY); }
export function notify(message, kind = 'error') {
  window.dispatchEvent(new CustomEvent('mailo:notice', { detail: { message, kind } }));
}
export async function apiFetch(url, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 120000);
  try {
    const token = getToken();
    const res = await fetch(url, {
      ...options, signal: options.signal || controller.signal,
      headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) }
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      if (res.status === 401 && !url.endsWith('/login')) {
        clearToken(); window.dispatchEvent(new Event('mailo:expired'));
      }
      const error = new Error(data.error || `Operazione non riuscita (${res.status}).`);
      error.status = res.status; throw error;
    }
    return res;
  } catch (err) {
    const message = err.name === 'AbortError' ? 'Richiesta scaduta. Verifica l’esito prima di ripetere un invio.' : err.message === 'Failed to fetch' ? 'Server non raggiungibile. Controlla la connessione e riprova.' : err.message;
    notify(message);
    err.reported = true;
    throw err;
  } finally { clearTimeout(timeout); }
}
export async function run(action) {
  try { return await action(); } catch (error) { if (!error.reported) notify(error.message || 'Operazione non riuscita.'); }
}
export const jsonOptions = (method, data) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
